export const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {  
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const isValidURL = (url: string) => {
  return /^(https?:\/\/)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,}(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/i.test(url);
};

    
  export const months = [
    { label: "January", value: "1" },
    { label: "February", value: "2" },
    { label: "March", value: "3" },
    { label: "April", value: "4" },
    { label: "May", value: "5" },
    { label: "June", value: "6" },
    { label: "July", value: "7" },
    { label: "August", value: "8" },
    { label: "September", value: "9" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" }
  ];


  export const sampleRecommendations = [
    {
      id: "1",
      user_id: 'user1',
      user_message: '',
      user_skills: '',
      reviewer_id: 'rev1',
      reviewer_email: null,
      reviewer_name: 'David H.',
      reviewer_company: 'Amazon',
      reviewer_designation: 'Product Innovations',
      reviewer_linkedIn_url: '',
      reviewer_message: '',
      video_url: 'https://crterraformmain.blob.core.windows.net/dailyrecordings/sample1.mp4',
      review_type: 'video',
      video_thumbnail:"",
      text_review:'Galle is a city on the southwest coast of Sri Lanka. It’s known for Galle Fort, the fortified old city founded by Portuguese colonists in the 16th century. Stone sea walls, expanded by the Dutch, encircle car-free streets with architecture reflecting Portuguese, Dutch and British rule. Notable buildings include the 18th-century Dutch Reformed Church. Galle Lighthouse stands on the fort’s southeast tip.',
      status: 'private',
      review_given: 0,
      reviewer_profile_picture:'https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg',
      review_slug: '',
  
    },
    {
      id: "2",
      user_id: 'user1',
      user_message: '',
      user_skills: '',
      reviewer_id: 'rev1',
      reviewer_email: null,
      reviewer_name: 'David H.',
      reviewer_company: 'Amazon',
      reviewer_designation: 'Product Innovations',
      reviewer_linkedIn_url: '',
      reviewer_message: '',
      video_url: 'https://crterraformmain.blob.core.windows.net/dailyrecordings/sample1.mp4',
      review_type: 'text',
      video_thumbnail:"https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg",
      text_review:'Galle is a city on the southwest coast of Sri Lanka. It’s known for Galle Fort, the fortified old city founded by Portuguese colonists in the 16th century. Stone sea walls, expanded by the Dutch, encircle car-free streets with architecture reflecting Portuguese, Dutch and British rule. Notable buildings include the 18th-century Dutch Reformed Church. Galle Lighthouse stands on the fort’s southeast tip.',
      status: 'private',
      review_given: 0,
      reviewer_profile_picture:'https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg',
      review_slug: ''
    },
    {
      id: "3",
      user_id: 'user1',
      user_message: '',
      user_skills: '',
      reviewer_id: 'rev1',
      reviewer_email: null,
      reviewer_name: 'David H.',
      reviewer_company: 'Amazon',
      reviewer_designation: 'Product Innovations',
      reviewer_linkedIn_url: '',
      reviewer_message: '',
      video_url: 'https://crterraformmain.blob.core.windows.net/dailyrecordings/sample2.mp4',
      review_type: 'video',
      video_thumbnail:"https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg",
      text_review:'Galle is a city on the southwest coast of Sri Lanka. It’s known for Galle Fort, the fortified old city founded by Portuguese colonists in the 16th century. Stone sea walls, expanded by the Dutch, encircle car-free streets with architecture reflecting Portuguese, Dutch and British rule. Notable buildings include the 18th-century Dutch Reformed Church. Galle Lighthouse stands on the fort’s southeast tip.',
      status: 'public',
      review_given: 0,
      reviewer_profile_picture:'https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg',
      review_slug: ''
    },
    {
      id: "4",
      user_id: 'user1',
      user_message: '',
      user_skills: '',
      reviewer_id: 'rev1',
      reviewer_email: null,
      reviewer_name: 'David H.',
      reviewer_company: 'Amazon',
      reviewer_designation: 'Product Innovations',
      reviewer_linkedIn_url: '',
      reviewer_message: '',
      video_url: 'https://crterraformmain.blob.core.windows.net/dailyrecordings/sample2.mp4',
      review_type: 'text',
      video_thumbnail:"https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg",
      text_review:'Galle is a city on the southwest coast of Sri Lanka. It’s known for Galle Fort, the fortified old city founded by Portuguese colonists in the 16th century. Stone sea walls, expanded by the Dutch, encircle car-free streets with architecture reflecting Portuguese, Dutch and British rule. Notable buildings include the 18th-century Dutch Reformed Church. Galle Lighthouse stands on the fort’s southeast tip.',
      status: 'private',
      review_given: 0,
      reviewer_profile_picture:'https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg',
      review_slug: ''
    },
    {
      id: "5",
      user_id: 'user1',
      user_message: '',
      user_skills: '',
      reviewer_id: 'rev1',
      reviewer_email: null,
      reviewer_name: 'David H.',
      reviewer_company: 'Amazon',
      reviewer_designation: 'Product Innovations',
      reviewer_linkedIn_url: '',
      reviewer_message: '',
      video_url: 'https://crterraformmain.blob.core.windows.net/dailyrecordings/sample2.mp4',
      review_type: 'text',
      video_thumbnail:"https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg",
      text_review:'Galle is a city on the southwest coast of Sri Lanka. It’s known for Galle Fort, the fortified old city founded by Portuguese colonists in the 16th century. Stone sea walls, expanded by the Dutch, encircle car-free streets with architecture reflecting Portuguese, Dutch and British rule. Notable buildings include the 18th-century Dutch Reformed Church. Galle Lighthouse stands on the fort’s southeast tip.',
      status: 'public',
      review_given: 0,
      reviewer_profile_picture:'https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg',
      review_slug: ''
    },
    {
      id: "6",
      user_id: 'user1',
      user_message: '',
      user_skills: '',
      reviewer_id: 'rev1',
      reviewer_email: null,
      reviewer_name: 'David H.',
      reviewer_company: 'Amazon',
      reviewer_designation: 'Product Innovations',
      reviewer_linkedIn_url: '',
      reviewer_message: '',
      video_url: 'https://crterraformmain.blob.core.windows.net/dailyrecordings/sample2.mp4',
      review_type: 'text',
      video_thumbnail:"https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg",
      text_review:'Galle is a city on the southwest coast of Sri Lanka. It’s known for Galle Fort, the fortified old city founded by Portuguese colonists in the 16th century. Stone sea walls, expanded by the Dutch, encircle car-free streets with architecture reflecting Portuguese, Dutch and British rule. Notable buildings include the 18th-century Dutch Reformed Church. Galle Lighthouse stands on the fort’s southeast tip.',
      status: 'private',
      review_given: 0,
      reviewer_profile_picture:'https://crterraformmain.blob.core.windows.net/crimages/placeholder-images/avatar-1.jpg',
      review_slug: ''
    }
  ];
  
  